module.exports = __webpack_public_path__ + "img/complement.74c521de.png";